module.exports = __webpack_public_path__ + "img/program-pap.ac7df90e.png";